// extracted by mini-css-extract-plugin
export var actionIcon = "_nh-0";